import { render, staticRenderFns } from "./ForgotPasswordThankYou.vue?vue&type=template&id=7ba84b73&scoped=true"
import script from "./ForgotPasswordThankYou.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordThankYou.vue?vue&type=script&lang=ts"
import style0 from "./ForgotPasswordThankYou.vue?vue&type=style&index=0&id=7ba84b73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba84b73",
  null
  
)

export default component.exports